import { render, staticRenderFns } from "./campaign-update.vue?vue&type=template&id=94f1d634"
import script from "./campaign-update.vue?vue&type=script&lang=js"
export * from "./campaign-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports